import React from "react";
import Susan from "../AllImages/Susan.jpeg";
import Luis from "../AllImages/Luis.jpg";
import Ruben from "../AllImages/Rubenn.png";
import Discord from "../AllImages/Diiiscord.jpg";

const OnlineSectionals = () => {
  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen text-gray-800 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Intro Text */}
        <p className="mb-12 text-xl text-center text-gray-700 font-medium">
          Antes de que comience la gira, tendremos ensayos online con todos los
          miembros de la orquesta.
        </p>

        {/* Two-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Strings Rehearsal Box */}
          <div className="bg-white border border-red-200 rounded-2xl shadow-lg hover:shadow-xl transition p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-6 text-center">
              🎻 Ensayos de Cuerdas
            </h2>

            {/* April 11 - Susan */}
            <RehearsalCard
              img={Susan}
              date="April 11, 2026"
              teacher="Susan Teacher"
              sessions={["Violins: 12-2pm", "Violas: 3-4pm", "Cellos + Basses: 5-6pm"]}
            />

            {/* April 18 - Luis */}
            <RehearsalCard
              img={Luis}
              date="April 18, 2026"
              teacher="Luis Teacher (Competition Workshop)"
              sessions={["Violins: 12-2pm", "Violas: 3-4pm", "Cellos + Basses: 5-6pm"]}
            />

            {/* April 25 - Susan */}
            <RehearsalCard
              img={Susan}
              date="April 25, 2026"
              teacher="Susan Teacher + Special Guest (Competition Workshop)"
              sessions={["Violins: 12-2pm", "Violas: 3-4pm", "Cellos + Basses: 5-6pm"]}
            />

            <div className="mt-6 text-center">
              <a
                href="https://discord.gg/FN53BDT7"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-6 rounded-full transition">
                  Entrar al Ensayo
                </button>
              </a>
            </div>
          </div>

          {/* Winds + Percussion Rehearsal Box */}
          <div className="bg-white border border-red-200 rounded-2xl shadow-lg hover:shadow-xl transition p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-6 text-center">
              🎺 Ensayos de Vientos + Percusión
            </h2>

            {/* April 11 - Luis */}
            <RehearsalCard
              img={Luis}
              date="April 11, 2026"
              teacher="Luis Teacher"
              sessions={["Woodwinds: 12-2pm", "Brass: 3-4pm", "Percussion + Basses: 5-6pm"]}
            />

            {/* April 18 - Ruben */}
            <RehearsalCard
              img={Ruben}
              date="April 18, 2026"
              teacher="Ruben Teacher (Competition Workshop)"
              sessions={["Woodwinds: 12-2pm", "Brass: 3-4pm", "Percussion + Basses: 5-6pm"]}
            />

            {/* April 25 - Ruben */}
            <RehearsalCard
              img={Ruben}
              date="April 25, 2026"
              teacher="Ruben Teacher + Special Guest (Competition Workshop)"
              sessions={["Woodwinds: 12-2pm", "Brass: 3-4pm", "Percussion + Basses: 5-6pm"]}
            />

            <div className="mt-6 text-center">
              <a
                href="https://discord.gg/FN53BDT7"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-6 rounded-full transition">
                  Entrar al Ensayo
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const RehearsalCard = ({ img, date, teacher, sessions }) => (
  <div className="flex items-start mb-6">
    <div className="relative mr-4">
      <img
        src={img}
        alt={teacher}
        className="w-16 h-16 object-cover rounded-full border-2 border-red-300 shadow-md"
      />
      <img
        src={Discord}
        alt="Discord"
        className="w-8 h-8 object-cover rounded-full border-2 border-white shadow-md absolute -bottom-1 -right-1"
      />
    </div>
    <div>
      <h3 className="text-lg font-semibold text-gray-800 mb-1">
        {date} <span className="text-sm text-gray-500">({teacher})</span>
      </h3>
      <ul className="list-disc list-inside ml-4 text-sm text-gray-700">
        {sessions.map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ul>
    </div>
  </div>
);

export default OnlineSectionals;
